window.initHomeBannerSlider = function(sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  function updateNavigationColor(swiper) {
    var slide = swiper.slides[swiper.activeIndex];
    var navPaginationContainer = swiper.$el.find('.wb-home-banner__nav-pagination-container');
    if (slide && swiper.$(slide).attr('data-swiper-slide-dark') === 'true') {
      navPaginationContainer.addClass('wb-home-banner__nav-pagination-container--dark');
    } else {
      navPaginationContainer.removeClass('wb-home-banner__nav-pagination-container--dark');
    }
  }
  return new Swiper(elSwiper, {
    on: {
      init: function () {
        var swiper = this;
        var removeSlideIndices = [];
        swiper.slides.each(function (index, slide) {
          if (swiper.$(slide).find('.wb-home-banner__item.wb-home-banner__item--dark').length > 0) {
            swiper.$(slide).attr('data-swiper-slide-dark', true);
          }
          if (window.getComputedStyle(slide).getPropertyValue('display') !== 'none') {
            return;
          }
          removeSlideIndices.push(parseInt(swiper.$(slide).attr('data-swiper-slide-index'), 10));
        });
        swiper.removeSlide(removeSlideIndices);
        swiper.update();
        if (swiper.slides.length - (swiper.loopedSlides * 2) < 2) {
          elSwiper.querySelector('.wb-home-banner__nav-pagination-container').style.display = 'none';
          swiper.allowTouchMove = false;
          swiper.allowSlidePrev = false;
          swiper.allowSlideNext = false;
          swiper.update();
        }
        updateNavigationColor(swiper);
      },
      slideChange: function() {
        var swiper = this;
        updateNavigationColor(swiper);
      }
    },
    navigation: {
      nextEl: sliderId + ' .wb-home-banner__nav-next',
      prevEl: sliderId + ' .wb-home-banner__nav-prev',
      disabledClass: 'wb-home-banner__nav--disabled',
      hiddenClass: 'wb-home-banner__nav--disabled'
    },
    pagination: {
      el: sliderId + ' .wb-home-banner__pagination',
      clickable: true,
      bulletClass: 'wb-home-banner__bullet',
      bulletActiveClass: 'wb-home-banner__bullet--active'
    },
    slidesPerView: 1,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    autoplay: {
    delay: 8000,
    },
    speed: 700,
    loop: true,
    lazyLoad: true
  });
}

window.initProductSlider = function (sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  var nextElement = null;
  var prevElement = null;
  if (currentLang == 'ar') {
    nextElement = sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-prev, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-prev';
    prevElement = sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-next, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-next';
  }
  else {
    nextElement = sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-next, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-next';
    prevElement = sliderId + ' + .wb-product-slider__nav .wb-product-slider__nav-prev, ' + sliderId + ' > .wb-product-slider__nav .wb-product-slider__nav-prev';
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: nextElement,
      prevEl: prevElement,
      disabledClass: 'wb-product-slider__nav--disabled',
      hiddenClass: 'wb-product-slider__nav--disabled'
    },
    scrollbar: {
      el: '.wb-product-slider__scrollbar',
      // dragClass: 'wb-product-slider__scrollbar-drag',
      enabled: false,
      dragSize: 40,
      draggable: false
    },
    slidesPerView: 2.25,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        scrollbar: {
           dragSize: 60,
        }
      },
      1300: {
        slidesPerView: 4,
        scrollbar: {
           dragSize: 60,
        },
      },
    },
    lazyLoad: true
  });
}

window.onQuickAddClicked = function (element, variantId, productHandle, productTitle, productImage) {
  var selectorContainer = '.wb-prdct20-fashion__quickadd-container',
      classActive = 'wb-quick-add__variants-item--active',
      classSuccess = 'wb-quick-add__success',
      classAdding = 'wb-quick-add__success--adding',
      classAdded = 'wb-quick-add__success--added';
  if (element.classList.contains(classActive)) {
    return;
  }
  var elContainer = element.closest(selectorContainer);
  elContainer.style.opacity = 1;
  element.classList.add(classActive);
  var addToCartData = { id: variantId, quantity: 1 };
  if (Cookies.get('adfb') !== undefined){
  addToCartData = { id: variantId,
                   quantity: 1,
                   properties: {'ad': 'FB'}
                  };
  }else if(Cookies.get('adig') !== undefined){
     addToCartData = { id: variantId,
                   quantity: 1,
                   properties: {'ad': 'IG'}
                  };
  }

  /*
  var shippingDiscount = Cookies.get('WBShippingDiscount');
  if (shippingDiscount && document.documentElement.classList.contains('wb-us')) {
    addToCartData.properties = addToCartData.properties || {};
    addToCartData.properties._shipping_discount = shippingDiscount;
  }
  */

  axios.post('/cart/add.json', addToCartData)
  .then(function (response) {
    //console.log('quick add product', variantId);
    var circleSvg = '<svg class="wb-quick-add__success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="25"></circle></svg>';
    var loadingSvg = '<svg class="wb-quick-add__success--check" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polyline points="11.6,20 15.9,24.2 26.4,13.8"></polyline></svg>';
    var domString = '<div class="' + classSuccess + '">' + circleSvg + loadingSvg + '</div>';
    var parser = new DOMParser();
    var elSuccess = parser.parseFromString(domString, 'text/html').body.firstChild;
    if(window.Cookies.get('special-offer') !== undefined){
            window.WBupdateCartNote('special-offer');
    }
    document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));
    
       if (true) {
            vueapp.loadCart();
            // vueapp.eeAddToCart(product, index);
            document.dispatchEvent(new CustomEvent('wb:checkloadedcartItems'));
          
            if (element.closest('.wb-cart-tabs-container') && window.location.pathname.indexOf('/cart') !== -1) {
                vueapp.$scrollTo({el: '#cartform', duration: 1000});
            }
        }
      if(window.location.pathname != 'cart'){
          sidecart._data.show = true;
        }
    
    element.appendChild(elSuccess);
    elSuccess.classList.add(classAdding);
    setTimeout(function () {
      elSuccess.classList.add(classAdded);
      setTimeout(function () {
      
     
        
        //document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));

        
          elSuccess.classList.remove(classAdding);
          elSuccess.classList.remove(classAdded);
          element.classList.remove(classActive);
        
        /*
        window.wbHeader.showCartCheck(element, function () {
          elSuccess.classList.remove(classAdding);
          elSuccess.classList.remove(classAdded);
          setTimeout(function () {
            element.removeChild(elSuccess);
            element.classList.remove(classActive);
            elContainer.style.opacity = null;
          }, 225);
        }, true);
        */
      }, 225);
    }, 1000);
  })
  .catch(function (error) {
    console.log(error);
   element.classList.remove(classActive);
    elContainer.style.opacity = null;
  });
}

window.onQuickAddToggle = function (element) {
  element.classList.toggle('wb-quick-add__toggle--active');
  $(element.nextElementSibling).slideToggle(225);
}

document.addEventListener('DOMContentLoaded', function () {
  window.initHomeBannerSlider('#home_banner--fitnesspromo');

  window.initProductSlider('#recom_slider_sportswear');
  window.initProductSlider('#recom_slider_sportswear--favorites');
  window.initProductSlider('#recom_slider_sportswear--nostalgia');
  window.initProductSlider('#recom_slider_sportswear--deal');
  window.initProductSlider('#recom_slider_sportswear--define');
  window.initProductSlider('#recom_slider_sportswear--newin');
  window.initProductSlider('#recom_slider_sportswear--newstyles');
  window.initProductSlider('#recom_slider_sportswear--power');
  window.initProductSlider('#recom_slider_sportswear--comfort');
  window.initProductSlider('#recom_slider_sportswear--outlet');
  window.initProductSlider('#recom_slider_sportswear--essential');
  window.initProductSlider('#recom_slider');
  window.initProductSlider('#recom_slider--favorites');
  window.initProductSlider('#recom_slider--newin');
  window.initProductSlider('#recom_slider--restock');
  window.initProductSlider('#recom_slider--gift-guide');
//  window.initProductSlider('#product_image_slider_mobile_thumbs');
  window.initProductSlider('#recom_slider--bundles');
  window.initProductSlider('#recom_slider_sportswear--wear-bestseller');
  window.initProductSlider('#recom_slider_sportswear--blackfriday-deal-fashion');
  window.initProductSlider('#recom_slider_sportswear--gift-guide');


  // setTimeout(function () {
  //   window.initProductSlider('#newin_slider_sportswear');
  //   window.initProductSlider('#newin_slider');
  // }, 400);

function elementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset &&
    left >= window.pageXOffset &&
    (top + height) <= (window.pageYOffset + window.innerHeight) &&
    (left + width) <= (window.pageXOffset + window.innerWidth)
  );
}
  
  var swiperElement = document.getElementById('home_banner');
  var swiperElementRestock = document.getElementById('home_banner_restock');
  var swiperElementFashionIndex = document.getElementById('home_banner--fashion-index');
  if(swiperElement != undefined){
  var interval = setInterval(function(){
          if(elementInViewport(swiperElement)){
            window.initHomeBannerSlider('#home_banner');
             clearInterval(interval);
           }
      }, 500);
  }
  if(swiperElementRestock != undefined){
  var intervalRestock = setInterval(function(){
          if(elementInViewport(swiperElementRestock)){
            window.initHomeBannerSlider('#home_banner_restock');
             clearInterval(intervalRestock);
           }
      }, 500);
  }

  if(swiperElementFashionIndex != undefined){
  var intervalFashionIndex = setInterval(function(){
          if(elementInViewport(swiperElementFashionIndex)){
            window.initHomeBannerSlider('#home_banner--fashion-index');
             clearInterval(intervalFashionIndex);
           }
      }, 500);
  }

  
  
  setTimeout(function () {
    if (window.initCabSlider) {
      window.initCabSlider();
    }
  }, 500);
}, { passive: true });


window.orderAgain = function (element,variantId, productHandle,productTitle,productImage) {


  var addToCartData = { id: variantId, quantity:1};

  axios.post('/cart/add.json', addToCartData)
  .then(function (response) {

    document.dispatchEvent(new CustomEvent('wb:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));
    document.dispatchEvent(new CustomEvent('wb:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', prodID: response.data.product_id, variantID: response.data.variant_id } }));
  })

  .catch (function (error) {

    document.dispatchEvent(new CustomEvent('wb:alert', {detail: {element:element}}));

  })
}

window.onQuickAddSizeClicked = function (element, productId, productHandle) {
  var selectorContainer = '.wb-prdct20-fashion__quickadd-container',
    selectorItem = '.wb-quick-add__variants-item',
    selectorSizeItem = '.wb-quick-add__variants-size-wrapper .wb-quick-add__variants-item',
    selectorLengthTitle = '.wb-quick-add__title-length',
    selectorLengthWrapper = '.wb-quick-add__variants-length-wrapper',
    classSoldout = 'wb-quick-add__variants-item--soldout',
    classActive = 'wb-quick-add__variants-item--active',
    selectorItemActive = '.wb-quick-add__variants-item.wb-quick-add__variants-item--active';
  var elContainer = element.closest(selectorContainer);
  var size = element.dataset.quickaddSize.toLowerCase();
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) { return variant.title.toLowerCase().indexOf(size + ' -') === 0; });
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);

  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var length = el.dataset.quickaddLength.toLowerCase();
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; })[0];
    if (!variant) {
      el.style.display = 'none';
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
    el.classList.remove(classSoldout);
    el.removeAttribute('disabled');
    elSvg.style.display = 'none';
    el.setAttribute('data-quickadd-variant-id', variant.id);
  });

  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });
  element.classList.add(classActive);
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);

  elLengthTitle.style.position = null;
  elLengthTitle.style.zIndex = null;
  elLengthWrapper.style.position = null;
  elLengthWrapper.style.zIndex = null;
  elLengthWrapper.style.display = 'flex';
}

window.onQuickAddLengthClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

window.selectFilterProductsBySize = function(sizeType, element) {
  var inputElement = document.getElementById('variant-id');
  if (inputElement) {
    inputElement.value = '';
  }
  var section = element.closest('.product-size-section');

  var variants = section.querySelectorAll('.wb-product--logovariant');
  variants.forEach(function(variant) {
    variant.classList.remove('active');
  });

  element.classList.add('active');

  window.filterProductsBySize(sizeType, section);
}

window.filterProductsBySize = function(sizeType, section) {
  var regularItems = section.querySelectorAll('.regular');
  var sevenEightItems = section.querySelectorAll('.seven-eight');
  var shortItems = section.querySelectorAll('.short');
  var longItems = section.querySelectorAll('.long');
  var regularContent = section.querySelectorAll('.regular-size-content');
  var sevenEightContent = section.querySelectorAll('.seven-eight-size-content');
  var shortContent = section.querySelectorAll('.short-size-content');
  var longContent = section.querySelectorAll('.long-size-content');

  function toggleDisplay(items, content, displayStyle, isActive) {
    items.forEach(function(item) {
      item.style.display = displayStyle;
      if (!isActive) {
        item.classList.remove('active');
      }
    });
    content.forEach(function(item) {
      item.style.display = displayStyle;
    });
  }

  toggleDisplay(regularItems, regularContent, 'none', false);
  toggleDisplay(shortItems, shortContent, 'none', false);
  toggleDisplay(longItems, longContent, 'none', false);
  toggleDisplay(sevenEightItems, sevenEightContent, 'none', false);

  if (sizeType === 'Regular') {
    toggleDisplay(regularItems, regularContent, '', true);
  } else if (sizeType === 'Short') {
    toggleDisplay(shortItems, shortContent, '', true);
  } else if (sizeType === 'Long') {
    toggleDisplay(longItems, longContent, '', true);
  } else if (sizeType === '7/8') {
    toggleDisplay(sevenEightItems, sevenEightContent, '', true);
  }
}